document.querySelector('body').addEventListener('click', event => {
    const closeButton = event.target.closest('.header__info__close');
    if (closeButton) {
        event.preventDefault();
        $('.header__info').slideUp(); 
        $('.main').addClass('main-small');
        $('.header').addClass('header-small');
        $('.popup').addClass('popup-small');
    }

    if (event.target.closest('.js-open-phones')) {
        event.preventDefault();
        const phoneOpener = event.target.closest('.js-open-phones');
        const isActive = phoneOpener.classList.contains('active');
        if (document.querySelector('.header__menu')) {
            document.querySelector('.header__menu').classList.remove('open');
        }
        document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
        
        if (isActive) {
            phoneOpener.classList.remove('active');
            document.querySelector('.header__phone').classList.remove('show');
            document.querySelector('body').classList.remove('body__phones__open');
            document.querySelector('body').classList.remove('body__menu__open');
        } else {
            phoneOpener.classList.add('active');
            document.querySelector('.header__phone').classList.add('show');
            document.querySelector('body').classList.add('body__phones__open');
        }
    }
    
    if (event.target.closest('.header__phone__dropdown__close')) {
        document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
        document.querySelector('.header__phone').classList.remove('show');
        document.querySelector('body').classList.remove('body__phones__open');
        document.querySelector('body').classList.remove('body__menu__open');
    }

    if (event.target.closest('.js-open-menu')) {
        event.preventDefault();
        const menuOpener = event.target.closest('.js-open-menu');
        const isActive = menuOpener.classList.contains('active');
        document.querySelector('body').classList.toggle('body__menu__open');
        document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
        if (document.querySelector('.header__phone')) {
            document.querySelector('.header__phone').classList.remove('show');
            document.querySelector('body').classList.remove('body__phones__open');
        }
        
        if (document.querySelector('.popup')) {
            document.querySelector('.popup').classList.remove('popup__open');
            document.querySelector('body').classList.remove('body__popup__open');
        }
        
        document.querySelector('.header__menu').classList.toggle('open');
        

        if (isActive) {
            menuOpener.classList.remove('active');
        } else {
            menuOpener.classList.add('active');
        }
    }

    if (window.innerWidth < 992 && event.target.closest('.header__menu__item__drop a.header__menu__link')) {
        event.preventDefault();
        const dropItem = event.target.closest('.header__menu__item__drop');
        const isActive = dropItem.classList.contains('active');
        
        if (isActive) {
            dropItem.classList.remove('active');
        } else {
            document.querySelectorAll('.header__menu__item__drop').forEach(el => {
                el.classList.remove('active');
            });
            dropItem.classList.add('active');
        }
    }

    if (event.target.closest('.header__phone') && !event.target.closest('.header__phone__dropdown__close') && !event.target.closest('.js-open-phones')) {
        document.querySelectorAll('.header__panel__link').forEach(el => el.classList.remove('active'));
        document.querySelector('.header__phone').classList.remove('show');
        document.querySelector('body').classList.remove('body__phones__open');
        document.querySelector('body').classList.remove('body__menu__open');
    }

});


if (!document.querySelector('.header__info')) {
    $('.header__info').slideUp(); 
    $('.main').addClass('main-small');
    $('.header').addClass('header-small');
    $('.popup').addClass('popup-small');
}

const dateElement = document.querySelector('.header__tag__date');
if (dateElement ) {
    const targetDate = new Date(dateElement.textContent).getTime();

    const daysElement = document.getElementById('days');
    const hoursElement = document.getElementById('hours');
    const minutesElement = document.getElementById('minutes');
    const secondsElement = document.getElementById('seconds');

    function updateCountdown() {
        const now = new Date().getTime();
        const timeLeft = targetDate - now;
        
        if (timeLeft < 0) {
            daysElement.textContent = '0d';
            hoursElement.textContent = '0h';
            minutesElement.textContent = '0m';
            secondsElement.textContent = '0s';
            return;
        }
        
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
        
        daysElement.textContent = `${days}d`;
        hoursElement.textContent = `${hours}h`;
        minutesElement.textContent = `${minutes}m`;
        secondsElement.textContent = `${seconds}s`;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
}


const dropdowns = document.querySelectorAll('.header__menu__dropdown');
if (dropdowns.length > 0) {
    dropdowns.forEach(dropdown => {
        const items = dropdown.querySelectorAll('.header__menu__dropdown__block__item');
        const bigItems = dropdown.querySelectorAll('.header__menu__dropdown__block__item.big');
        const banner = dropdown.querySelector('.header__menu__dropdown__banner');
        
        if (!banner) return;
        
        if (bigItems.length > 0 && items.length > 2) {
            banner.classList.add('hidden');
        }
        else if (items.length > 3) {
            banner.classList.add('hidden');
        } else if (items.length <= 3) {
            banner.classList.remove('hidden');
        }
    });
}

if (document.querySelector('.header__panel')) {
    let lastScrollTop = 0;
    let ticking = false;
    const header = document.querySelector('header');
    const scrollThreshold = 50; // минимальное расстояние скролла для срабатывания
    
    function updateHeader(scrollTop) {
        if (Math.abs(scrollTop - lastScrollTop) > scrollThreshold) {
            if (scrollTop > lastScrollTop && scrollTop > 0) {
                // Скролл вниз и прокручено больше 100px
                header.classList.add('header_hide');
            } else if (scrollTop < lastScrollTop) {
                // Скролл вверх
                header.classList.remove('header_hide');
            }
            lastScrollTop = scrollTop;
        }
        ticking = false;
    }

    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateHeader(scrollTop);
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
}